import type { App } from 'vue'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import AdminPreset from '@/theme/preset'

export function setupPrimeVue(app: App) {
  app.use(PrimeVue, {
    theme: {
      preset: AdminPreset,
      options: { darkModeSelector: false },
    },
  })
  app.use(ToastService)
  app.use(ConfirmationService)
  app.directive('tooltip', Tooltip)
}
